import { useAtom } from 'jotai';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import MyCarSaleDealer from './Register/MyCarSaleDealer';
import MenuHeader from '@/components/Header/MenuHeader';
import { ChevronRightIcon } from '@/components/Icon';
// import MyListing from '@/components/Products/Sale/MyListing';
import { REPRESENTATIVE_NUMBER } from '@/const/common';
import { PRODUCT_TYPE_DIRECT, PRODUCT_TYPE_SPEED } from '@/const/products';
import DefaultHelmet from '@/metadatas/DefaultHelmet';
import { memberAtom } from '@/store/member';
import { phoneCall } from '@/utils/common';

const MyCarSaleMain = () => {
  const [memberAtomData] = useAtom(memberAtom);

  const isDealerType = memberAtomData?.type ? memberAtomData.type?.code !== 'NORMAL' : false;

  const navigate = useNavigate();

  useEffect(() => {
    sessionStorage.setItem('entryPoint', location.pathname);
  }, []);

  const handleClickSalesType = (type: string) => {
    navigate('/sell-car/guide', { state: { type: type } });
  };

  const handleClickSaleHelp = () => {
    navigate('/one-stop-service');
  };

  const saleMethods = [
    {
      badge: '수수료 0원',
      badgeClassName: 'bg-[#EFF6FF] text-[#3B5BDB]',
      title: '내 차 직접 팔기',
      description: '내가 직접 올리고, 사려는 사람이랑 바로 거래해요.',
      onClick: () => handleClickSalesType(PRODUCT_TYPE_DIRECT),
    },
    {
      badge: '빠른 판매',
      badgeClassName: 'bg-[#FEF3C7] text-[#D97706]',
      title: '직트럭에 매입 견적 요청',
      description: '견적 상담 후 직트럭에 바로 판매할 수 있어요.',
      onClick: () => handleClickSalesType(PRODUCT_TYPE_SPEED),
    },
    {
      badge: '유료 서비스',
      badgeClassName: 'bg-[#DCFCE7] text-[#15803D]',
      title: '내 차 판매 대행',
      description: '차량 판매가 어려우시다면 직트럭이 모든 과정을 도와드려요.',
      onClick: handleClickSaleHelp,
    },
  ];

  return (
    <>
      <MenuHeader title="내차 판매"></MenuHeader>
      {/* <DefaultHelmet page="sale" /> */}

      {isDealerType ? (
        <MyCarSaleDealer />
      ) : (
        <div className="w-full min-h-[100dvh] pt-[60px] bg-[#F7F8FA]">
          <MenuHeader title="내 차 팔기" bgColor="#F7F8FA"></MenuHeader>

          <div className="px-4 pt-6 pb-10">
            <h2 className="text-[28px] font-extrabold tracking-tight text-[#101828] leading-[120%]">
              어떤 방법으로
              <br />
              차량을 판매하고
              <br />
              싶으세요?
            </h2>
            <p className="mt-3 text-[13px] leading-[18px] font-medium text-[#99A1AF]">
              아래에서 원하는 방법을 선택해 주세요.
            </p>

            <div className="flex flex-col gap-3 mt-7">
              {saleMethods.map((method) => (
                <button
                  key={method.title}
                  type="button"
                  className="flex items-center w-full gap-4 p-5 text-left bg-white rounded-[16px] shadow"
                  onClick={method.onClick}
                >
                  <span className="flex-1">
                    <span className="flex items-center gap-2">
                      <span
                        className={`px-2 py-px rounded-full text-[11px] leading-[13px] font-bold ${method.badgeClassName}`}
                      >
                        {method.badge}
                      </span>
                    </span>
                    <span className="block mt-2 text-[19px] leading-[26px] font-extrabold text-[#101828]">
                      {method.title}
                    </span>
                    <span className="block mt-1 text-[13px] leading-[20px] font-medium text-[#99A1AF] break-keep">
                      {method.description}
                    </span>
                  </span>
                  <span className="flex items-center justify-center w-8 h-8 rounded-full shrink-0 bg-[#F9FAFB]">
                    <ChevronRightIcon color="#D1D5DC" width={16} height={16} />
                  </span>
                </button>
              ))}
            </div>

            <div className="mt-8 text-center">
              <p className="text-[12px] leading-[16px] font-medium text-[#99A1AF]">어떤 방법이 맞는지 모르겠으세요?</p>
              <button
                type="button"
                className="mt-1 text-[13px] leading-[18px] font-bold text-[#3B5BDB] underline underline-offset-2"
                onClick={() => phoneCall(REPRESENTATIVE_NUMBER)}
              >
                직트럭과 통화하기
              </button>
            </div>
          </div>
          {/* <div className="pb-16">
            <MyListing />
          </div> */}
        </div>
      )}
    </>
  );
};

export default MyCarSaleMain;
